export default "__VITE_ASSET__89e59179__"